// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2k2Kk","addWidgetButton":"Header_addWidgetButton__11O3A","dashboardTabs":"Header_dashboardTabs__X309g","active":"Header_active__3YYGe"};